var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrimma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      display: "block"
    },
    width: 50.9,
    height: 36.5,
    viewBox: "0 0 50.9 36.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.4499 36.25C36.2458 36.25 44.9976 29.6756 44.9976 21.5658C44.9976 13.4559 36.2458 6.88157 25.4499 6.88157C14.654 6.88157 5.90225 13.4559 5.90225 21.5658C5.90225 29.6756 14.654 36.25 25.4499 36.25Z",
    fill: "#F9F6F8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    stroke: "#8A8084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M46.8818 16.8083C46.8818 26.4616 34.0659 27.7237 25.2145 27.7237C16.3631 27.7237 3.54722 26.4616 3.54722 16.8083V7.69477L46.8818 7.3553V16.8083Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4A4547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M46.3302 16.5815C46.3302 25.5388 33.8202 26.7099 25.1802 26.7099C16.5401 26.7099 4.03018 25.5388 4.03018 16.5815V8.12491L46.3302 7.80991V16.5815Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F9F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.2145 25.738C26.7753 25.738 28.0407 24.4647 28.0407 22.894C28.0407 21.3233 26.7753 20.05 25.2145 20.05C23.6536 20.05 22.3883 21.3233 22.3883 22.894C22.3883 24.4647 23.6536 25.738 25.2145 25.738Z",
    fill: "#C5BABF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25.2698 24.28C26.0154 24.28 26.6198 23.6755 26.6198 22.93C26.6198 22.1844 26.0154 21.58 25.2698 21.58C24.5242 21.58 23.9198 22.1844 23.9198 22.93C23.9198 23.6755 24.5242 24.28 25.2698 24.28Z",
    fill: "#F9F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M45.1487 4.75H5.74278L3.85 12.8212L3.88426 13.4788C6.98466 17.6895 14.65 19.15 25.45 19.15C36.25 19.15 43.9154 17.6895 47.0157 13.4788L47.05 12.8212L45.1572 4.75H45.1487Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4A4547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M50.6413 3.56589C50.6413 17.6762 35.7317 18.2501 25.4457 18.2501C15.1596 18.2501 0.25 17.6762 0.25 3.56589H50.65H50.6413Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F2ECEF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    stroke: "#8A8084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M25.45 7.35526C39.3676 7.35526 50.65 5.7647 50.65 3.80263C50.65 1.84057 39.3676 0.25 25.45 0.25C11.5324 0.25 0.25 1.84057 0.25 3.80263C0.25 5.7647 11.5324 7.35526 25.45 7.35526Z",
    fill: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    stroke: "#8A8084"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrimma);
export default __webpack_public_path__ + "static/media/strimma.0b70ca2f3b262b133f7a0f072b805f41.svg";
export { ForwardRef as ReactComponent };